export default class AWSDynamoDBManager {
  constructor(DynamoDBClient) {
    this.ddb = DynamoDBClient;
  }

  //GETTER METHODS

  async ScanDB(params) {
    return new Promise(async (resolve, reject) => {
      try {
        // Call DynamoDB to scan the table
        console.log("Scanning DynamoDB with params:", params);
        const response = await this.scanDBPartial(params);
        console.log("Scan response:", response);

        var data = response.Items;
        var LastEvaluatedKey = response.LastEvaluatedKey;

        while (LastEvaluatedKey !== undefined) {
          const params2 = {
            ...params,
            ExclusiveStartKey: LastEvaluatedKey,
          };
          const response = await this.scanDBPartial(params2);
          data = [...data, ...response.Items];

          LastEvaluatedKey = response.LastEvaluatedKey;
        }
        resolve(data);
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  }

  async QueryDB(params) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.queryDBPartial(params);
        console.log(response);

        var data = response.Items;
        var LastEvaluatedKey = response.LastEvaluatedKey;

        while (LastEvaluatedKey !== undefined) {
          const params2 = {
            ...params,
            ExclusiveStartKey: LastEvaluatedKey,
          };

          const response = await this.queryDBPartial(params2);
          data = [...data, ...response.Items];

          LastEvaluatedKey = response.LastEvaluatedKey;
        }
        resolve(data);
      } catch (err) {
        console.log(err);
        reject(err);
      }
    });
  }

  // Fetch products from the server-side API endpoint
  async scanDBPartial(params) {
    return new Promise((resolve, reject) => {
      this.ddb.scan(params, function (err, data) {
        if (err) {
          console.log("Error", err);
          reject(err); // Reject the promise with the error
        } else {
          resolve(data); // Resolve the promise with the fetched data
        }
      });
    });
  }
  async queryDBPartial(params) {
    return new Promise((resolve, reject) => {
      this.ddb.query(params, function (err, data) {
        if (err) {
          console.log("Error", err);
          reject(err); // Reject the promise with the error
        } else {
          resolve(data); // Resolve the promise with the fetched data
        }
      });
    });
  }

  async GetItem(params) {
    // Call DynamoDB to delete the item from the table
    return new Promise((resolve, reject) => {
      this.ddb.getItem(params, function (err, data) {
        if (err) {
          console.log("Error", err);
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

  async PutItem(params) {
    return new Promise((resolve, reject) => {
      this.ddb.putItem(params, function (err, data) {
        if (err) {
          console.log("Error", err);
          reject(err);
        } else {
          resolve(data.Items);
        }
      });
    });
  }

  async UpdateItem(params) {
    return new Promise((resolve, reject) => {
      this.ddb.updateItem(params, function (err, data) {
        if (err) {
          console.log("Error", err);
          reject(err);
        } else {
          resolve("Ok");
        }
      });
    });
  }

  async DeleteItem(params) {
    // Call DynamoDB to delete the item from the table
    return new Promise((resolve, reject) => {
      this.ddb.deleteItem(params, function (err, data) {
        if (err) {
          console.log("Error", err);
          reject(err);
        } else {
          resolve("Ok");
        }
      });
    });
  }
}
